module.exports = "<div class=\"lang-circle lang-de\">\n  <div class=\"text-uppercase\" (click)=\"siwtchToGerman()\"> DE </div>\n</div>\n<div class=\"lang-circle lang-fr\">\n  <div class=\"text-uppercase\" (click)=\"siwtchToFrench()\"> FR </div>\n</div>\n<div class=\"lang-circle lang-en\">\n  <div class=\"text-uppercase\" (click)=\"siwtchToEnglish()\"> EN </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/top-bar/lang-switcher/lang-switcher.component.html
// module id = ./src/app/top-bar/lang-switcher/lang-switcher.component.html
// module chunks = main